<div
  class="form-list-main"
  *ngIf="!loading"
  infiniteScroll
  (scrolled)="onScroll()"
  [scrollWindow]="isScrollWindow()"
  [immediateCheck]="true"
  #infiniteScrollParentElem
>
  <div #infiniteScrollChildElem>
    <div *ngIf="timeline.groups.length" class="form-sort-by-hint">
      <span i18n>This form list is ordered by </span>
      <span *ngIf="sortFormsBy">{{ sortFormsBy }}</span>
      <span *ngIf="!sortFormsBy" i18n>creation date</span>
    </div>
    <div *ngFor="let timelineGroup of timeline?.groups">
      <div class="timeline sm-sticky sm-top-0 sm-z-10" *ngIf="timelineGroup.forms.length">
        <strong *ngIf="timelineGroup.timestamp"
          >{{ timelineGroup.timestamp | amDateFormat: 'ddd MMM D, YYYY' }}
        </strong>
        <strong *ngIf="!timelineGroup.timestamp" i18n>Not Set</strong>
        <span class="text-muted">({{ timelineGroup.forms.length }})</span>
      </div>
      <ul class="flex-wrap d-flex">
        <li *ngFor="let form of timelineGroup.forms" class="m-3 animate-fade-in">
          <cc-form-card [form]="form" [template]="template" [routerLink]="[form._id]"></cc-form-card>
        </li>
      </ul>
    </div>
    <div class="loading-spinner" *ngIf="loadingMore">
      <div class="cc-icon cc-icon-spinner-3x"></div>
    </div>
  </div>
  <div
    *ngIf="!loading && !timeline.forms.size"
    class="empty-state-container h-100 sm-relative sm-flex sm-flex-1 sm-justify-center sm-bg-cover"
  >
    <div class="empty-state">
      <h3 class="h3" i18n>No forms have been created</h3>
      <h5 class="h5" *ngIf="canAddForm" i18n>Click the green button on the right to get started.</h5>
    </div>
    <div class="empty-state-arrow" *ngIf="canAddForm">
      <i class="fa fa-arrow-up fa-2x text-success"></i>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
